module.exports = {
  footerText: 'فاطمه کاظمی زاده - fatemeh-kazemi.ir',
}
